export * from './register.component';
export * from './register-verify.component';
